<template>
  <div class="metadata-area">
    <div class="outer-wrapper">
      <div class="inner-wrapper">
        <div v-if="brandLogo" class="brand-logo">
          <img
            :src="require(`@/assets/images/detail/logo_${brandLogo}.png`)"
            :alt="`${brandLogo} 로고`"
          />
        </div>

        <h1 class="main-title">{{ movieTitle }}</h1>

        <PlayerMetaData
          :key="`${movieTitle}__meta_data`"
          :content-info="contentInfo"
          :content-type="contentType"
        />

        <PlayerComments
          :key="`${movieTitle}__player_comments`"
          :comment-list="comments"
        />

        <PlayerIconButtons
          :key="`${movieTitle}__icon_button`"
          :content-info="contentInfo"
          :content-type="contentType"
        />

        <div class="essential-buttons">
          <label v-if="hasMovieGroup" class="selector">
            <select v-model="selectedMovie" @change="goToSelectedMovie">
              <option
                v-for="movie in movieGroup"
                :key="movie.value"
                :value="movie.value"
              >
                {{ movie.text }}
              </option>
            </select>
          </label>

          <PlayerActionButton
            :key="`${movieTitle}__player_action_button`"
            :content-info="contentInfo"
            :content-type="contentType"
            @on-click-player="clickPlayerFn"
          />
        </div>

        <PlayerDetail
          :key="`${movieTitle}__detail_info`"
          :content-info="contentInfo"
          :content-type="contentType"
          @on-click-more="moveToDetailInfo"
        />
      </div>
    </div>

    <div v-if="hasNoticeList || hasEventList" class="outer-wrapper">
      <div class="inner-wrapper">
        <NoticeList v-if="hasNoticeList" :notice-list="noticeList" />

        <EventBannerList v-if="hasEventList" :event-banner-list="eventList" />
      </div>
    </div>
  </div>
</template>
<script>
  import { get } from 'lodash'
  import { mapGetters } from 'vuex'
  import { PATH_NAME_PLAYER_MOVIE_DETAIL_INFO } from '@/common/router.const'
  import { PLAYER_TYPE } from '@/common/player.const'

  // components
  import EventBannerList from '@/components/play/EventBannerList'
  import NoticeList from '@/components/play/NoticeList'
  import PlayerActionButton from '@/components/play/detail/PlayerActionButton'
  import PlayerComments from '@/components/play/detail/PlayerComments.vue'
  import PlayerDetail from '@/components/play/detail/PlayerDetail.vue'
  import PlayerIconButtons from '@/components/play/detail/PlayerIconButtons.vue'
  import PlayerMetaData from '@/components/play/detail/PlayerMetaData.vue'

  export default {
    name: 'MoviePlayerDetailInfo',
    components: {
      PlayerDetail,
      PlayerIconButtons,
      PlayerMetaData,
      NoticeList,
      EventBannerList,
      PlayerActionButton,
      PlayerComments,
    },
    props: {
      contentInfo: {
        type: Object,
        default: () => {},
      },
      clickPlayerFn: {
        type: Function,
        default: null,
      },
      noticeList: {
        type: Array,
        default: null,
      },
      eventList: {
        type: Array,
        default: null,
      },
    },
    data() {
      return {
        selectedMovie: get(this.$route, 'query.movieid', ''),
        contentType: PLAYER_TYPE.MOVIE,
      }
    },
    computed: {
      ...mapGetters(['userInfo']),
      brandLogo() {
        const wavveLogo = ['original', 'only']
        const brandLogo = get(this.contentInfo, 'brand_logolist.0', '')
        return wavveLogo.includes(brandLogo) ? `wavve_${brandLogo}` : brandLogo
      },
      contentId() {
        return get(this.contentInfo, 'movieid', '')
      },
      comments() {
        const { autocomment = '', comment = '' } = this.contentInfo
        return [autocomment, comment]
      },
      movieGroup() {
        return get(this.contentInfo, 'moviegroup.list', [])
      },
      movieTitle() {
        return get(this.contentInfo, 'title', '')
      },
      hasEventList() {
        return this.eventList.length > 0
      },
      hasMovieGroup() {
        return (
          this.movieGroup.length > 1 &&
          !get(this.contentInfo, 'originalmovieid', '')
        )
      },
      hasNoticeList() {
        return (this.noticeList || []).length > 0
      },
    },
    watch: {
      selected(newVal, oldVal) {
        const getMovieGroupItemByValue = (value) => {
          return get(this.contentInfo, 'moviegroup.list', []).filter(
            (item, index) => {
              return item.text === value
            },
          )[0]
        }
        if (newVal !== oldVal) {
          const newMovieGroupItem = getMovieGroupItemByValue(newVal)
          this.$router.push(
            '/player/movie?movieid=' + get(newMovieGroupItem, 'value', ''),
          )
        }
      },
    },
    methods: {
      moveToDetailInfo() {
        this.$router.push({
          name: PATH_NAME_PLAYER_MOVIE_DETAIL_INFO,
          query: {
            movieid: get(this.$route, 'query.movieid', ''),
          },
        })
      },
      goToSelectedMovie() {
        this.$router.replace(`/player/movie?movieid=${this.selectedMovie}`)
      },
    },
  }
</script>
